import Vue from 'vue'
import Vuex from 'vuex'
import {get,post,put,export_blob,del} from '@/api/index'
Vue.use(Vuex)
export default new Vuex.Store({
	strict: process.env.NODE_ENV !== 'production',
	state: {
		dictlist:{},
		buyerlist:[],
		brandlist:[],
		speclist:[],
		categorylist:[],
		supplierlist:[],
	},
	getters: {
	},
	mutations: {
	    SET_DICT(state, payload) {
			state.dictlist = payload
		},
	    SET_BUYER(state, payload) {
			state.buyerlist = payload
		},
	    SET_BRAND(state, payload) {
			state.brandlist = payload
		},
	    SET_SPEC(state, payload) {
			state.speclist = payload
		},
	    SET_CATEGORY(state, payload) {
			state.categorylist = payload
		},
	    SET_SUPPLIER(state, payload) {
			state.supplierlist = payload
		}
	},
	actions: {
		async loadDict({ state, commit }) {
			if(Object.keys(state.dictlist).length>0){
				return state.dictlist
			}
			const res = await get('index/getDictList',{}, false);
			commit('SET_DICT',res.data);
		},
		async getBuyerlist({ state, commit }){
			if(state.buyerlist.length>0){
				return state.buyerlist
			}
			const res = await post('buyer/getBuyerList',{}, false);
			commit('SET_BUYER',res.data);
		},
		async getBrandList({ state, commit }){
			if(state.brandlist.length>0){
				return state.brandlist
			}
			const res = await get('productbrand/getBrandList',{}, false);
			commit('SET_BRAND',res.data);
		},
		async getSpecList({ state, commit }){
			if(state.speclist.length>0){
				return state.speclist
			}
			const res = await get('spec/getSpecList',{}, false);
			commit('SET_SPEC',res.data);
		},
		async getCategoryList({ state, commit }){
			if(state.categorylist.length>0){
				return state.categorylist
			}
			const res = await get('productcategory/getCategoryList',{}, false);
			commit('SET_CATEGORY',res.data);
		},
		async getSupplierList({ state, commit }){
			if(Object.keys(state.supplierlist).length>0){
				return state.supplierlist
			}
			const res = await post('supplier/getSupplierList',{}, false);
			commit('SET_SUPPLIER',res.data);
		}
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js